import { render, staticRenderFns } from "./FormDesingView.vue?vue&type=template&id=42bd72a8&scoped=true&"
import script from "./FormDesingView.vue?vue&type=script&lang=js&"
export * from "./FormDesingView.vue?vue&type=script&lang=js&"
import style0 from "./FormDesingView.vue?vue&type=style&index=0&id=42bd72a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd72a8",
  null
  
)

export default component.exports